<template>
  <div class="container">
    <h4>QR Generator IDP STG - Instructions</h4>
    <p>
      <strong>Code Value: {{ codeValue }} </strong>
    </p>
    <div class="qr-container">
      <qrcode-vue :value="codeValue" :size="200" level="H"></qrcode-vue>

      <p>LOGIN ENVIRONMENT {{ selected }}</p>
      <div class="row">
        <div class="col">
          <p>
            Open this Toyota link on your mobile device.
            <a href="https://toyota.test-app.link/sms_registration"
              >https://toyota.test-app.link/sms_registration</a
            >
          </p>
          <p>
            Open this Lexus link on your mobile device.
            <a href="https://lexus.test-app.link/sms_registration"
              >https://lexus.test-app.link/sms_registration</a
            >
          </p>
          <p>
            Open this Subaru link on your mobile device.
            <a href="https://subaru.test-app.link/sms_registration"
              >https://subaru.test-app.link/sms_registration</a
            >
          </p>
          <p>Click "Generate New Code" button</p>
          <p>
            Scan QR code below from your mobile device's native camera or in
            OneApp.
          </p>
          <p>Watch magic happen</p>
        </div>
      </div>
    </div>
    <div class="row">
      <label class="message" for="selected">Select an Environment</label>
      <select
        class="form-select my-2"
        aria-label="Select an environment"
        v-model="selected"
      >
        <option selected>Select an environment</option>
        <option value="qa">QA</option>
        <option value="stg">STG</option>
      </select>

      <div class="row">
        <div class="py-3 col" style="text-align: center">
          <button class="ty-button" v-on:click="generateToyota">
            New Toyota Code
          </button>
        </div>
      </div>
      <div class="py-3 col" style="text-align: center">
        <button class="lx-button" v-on:click="generateLexus">
          New Lexus Code
        </button>
      </div>
      <div class="py-3 col" style="text-align: center">
        <button class="sub-button" v-on:click="generateSubaru">
          New Subaru Code
        </button>
      </div>
    </div>
    <div v-if="scanResponse">
      <p>Scan Response:</p>
      <p>{{ scanResponse }}</p>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import { analytics } from "../../config/firebaseInit";

export default {
  name: "QrGenIDPSTGFRN",
  data: function () {
    return {
      deepURLToyota:
        "https://toyota.test-app.link/sms_registration?$user_code=",
      deepURLLexus: "https://lexus.test-app.link/sms_registration?$user_code=",
      deepURLSubaru:
        "https://subaru.test-app.link/sms_registration?$user_code=",
      codeValue: "",
      scanResponse: null,
      selected: "qa",
    };
  },
  props: {
    msg: String,
  },
  components: {
    QrcodeVue,
  },
  created() {
    analytics.logEvent("qr-idp-frnative");
  },
  methods: {
    generateToyota: function () {
      // this.axios.get('https://us-central1-tmna-onescan.cloudfunctions.net/api/generate-code').then((response) => {
      //   this.codeValue = response.data.user_code
      // }).catch((e) => {
      //   console.log(e);
      //   this.codeValue = "1234"
      // })
      //https://idp.stg.connectedtech.io/oauth2/device/user?user_code=ecJT3q5C
      //https://idp.stg.connectedtech.io/oauth2/realms/root/realms/tmna/device/code
      //https://idp.stg.connectedtech.io/openam/device/code
      this.axios
        .post(
          `https://login.${this.selected}.toyotadriverslogin.com/oauth2/realms/tmna-native/device/code?response_type=token&scope=profile&client_id=headunitv2`,
          {
            headers: {
              Host: `login.${this.selected}.toyotadriverslogin.com`,
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((response) => {
          // eslint-disable-next-line
          console.log("qr response: ", response);
          this.scanResponse = response.data;
          const userCodeURL =
            `${response.data.verification_url}` +
            "?user_code=" +
            response.data.user_code;
          // const userCodeURL = `${this.deepURLToyota}` + response.data.user_code;
          this.codeValue = userCodeURL;
        })
        .catch(() => {
          this.codeValue = "Error";
        });
    },
    generateLexus: function () {
      // this.axios.get('https://us-central1-tmna-onescan.cloudfunctions.net/api/generate-code').then((response) => {
      //   this.codeValue = response.data.user_code
      // }).catch((e) => {
      //   console.log(e);
      //   this.codeValue = "1234"
      // })
      //https://idp.stg.connectedtech.io/oauth2/device/user?user_code=ecJT3q5C
      //https://idp.stg.connectedtech.io/oauth2/realms/root/realms/tmna/device/code
      //https://idp.stg.connectedtech.io/openam/device/code
      this.axios
        .post(
          `https://login.${this.selected}.lexusdriverslogin.com/oauth2/realms/tmna-native/device/code?response_type=token&scope=profile&client_id=headunitv2`,
          {
            headers: {
              Host: `login.${this.selected}.lexusdriverslogin.com`,
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((response) => {
          // eslint-disable-next-line
          console.log("qr response: ", response);
          this.scanResponse = response.data;
          const userCodeURL =
            `${response.data.verification_url}` +
            "?user_code=" +
            response.data.user_code;
          // const userCodeURL = `${this.deepURLLexus}` +  response.data.user_code;
          this.codeValue = userCodeURL;
        })
        .catch(() => {
          this.codeValue = "Error";
        });
    },
    generateSubaru: function () {
      // this.axios.get('https://us-central1-tmna-onescan.cloudfunctions.net/api/generate-code').then((response) => {
      //   this.codeValue = response.data.user_code
      // }).catch((e) => {
      //   console.log(e);
      //   this.codeValue = "1234"
      // })
      //https://idp.stg.connectedtech.io/oauth2/device/user?user_code=ecJT3q5C
      //https://idp.stg.connectedtech.io/oauth2/realms/root/realms/tmna/device/code
      //https://idp.stg.connectedtech.io/openam/device/code
      const subClientId = "eef246b5fcd34c35bcc711db6cf537c5.hu.subaru.com";
      // const subClientSecret = "subaru-native-secret";
      this.axios
        .post(
          `https://login.${this.selected}.subarudriverslogin.com/oauth2/realms/tmna-native/device/code?response_type=token&scope=profile&client_id=${subClientId}`,
          {
            headers: {
              Host: `login.${this.selected}.subarudriverslogin.com`,
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((response) => {
          // eslint-disable-next-line
          console.log("qr response: ", response);
          this.scanResponse = response.data;
          const userCodeURL =
            `${response.data.verification_url}` +
            "?user_code=" +
            response.data.user_code;
          this.codeValue = userCodeURL;
        })
        .catch(() => {
          this.codeValue = "Error";
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
body {
  font-family: ToyotaType-Regular;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.ty-button {
  background: #d92429;
  border-radius: 70px;
  width: 240px;
  height: 64px;
  font-family: ToyotaType-Semibold;
  font-size: 20px;
  color: #ffffff;
  letter-spacing: 0.73px;
  text-align: center;
}

.lx-button {
  background: #000000;
  border-radius: 70px;
  width: 240px;
  height: 64px;
  font-family: ToyotaType-Semibold;
  font-size: 20px;
  color: #ffffff;
  letter-spacing: 0.73px;
  text-align: center;
}
.sub-button {
  background: #26599a;
  border-radius: 70px;
  width: 240px;
  height: 64px;
  font-family: ToyotaType-Semibold;
  font-size: 20px;
  color: #ffffff;
  letter-spacing: 0.73px;
  text-align: center;
}
.qr-container {
  padding-top: 40px;
  text-align: center;
  height: 300px;
  /*background-color: #4281ff;*/
  height: 540px;
}
</style>
